import $ from 'jquery';
import 'corejs-typeahead';
import memoize from 'lodash.memoize';
import * as CONFIG from './../../../../webpack/_config';

const SUGGESTION_URL = CONFIG.API_PATH;
const SUGGESTION_SIZE = 15; // max number of results to show for each section in autosuggest

export default class SearchBar {
  constructor() {
    const searchBar = $('.hero__autosuggest');
    const pracInput = $('#search_str, #mobile_search_str');
    const suburbInput = $('#search_zip');
    const mobileSuburbInput = $('#mobile_search_zip');
    const secondarySuburbInput = $('#secondary_search_zip');
    const searchType = searchBar.data('type');

    // Populate search form
    const zipValue = window.localStorage.getItem('zipCode');
    const keywordValue = window.localStorage.getItem('keywords');

    suburbInput.bind('typeahead:selected', () => this.updateSearchZipAutocomplete(1));
    mobileSuburbInput.bind('typeahead:selected', () => this.updateSearchZipAutocomplete(1));
    secondarySuburbInput.bind('typeahead:selected', () => this.updateSearchZipAutocomplete(1));

    // Define initial state
    const state = {
      categories: { count: 0, visible: true },
      courses: { count: 0, visible: false },
      productCategories: { count: 0, visible: false }
    };

    // Modify state based on search type
    if (pracInput.length) {
      switch (searchType) {
        case 'product':
          state.productCategories.visible = true;
          break;
        case 'schools':
          state.courses.visible = true;
          state.categories.visible = false;
          break;
        default:
          break;
      }
    }

    const headerTemplate = (section, title) => `
    <div style="cursor: pointer" class="section-title ${state[section].visible ? 'active' : 'inactive'}">
        ${title}

        <div class="float-right">
          <span class="count">${state[section].count} Results</span>
          <button><span class="vively-${state[section].visible ? 'up' : 'down'}"></span></button>
        </div>
      </div>
    `;

    const standardSuggestion = data => `<div><div class="suggestion__text"><span>Browse</span> ${data.name}</div></div>`;


    const fetchSuggestions = memoize(
      q => $.ajax(
        `${SUGGESTION_URL}fuzzimatch?laravel=1&keyword=${q}`
         + `&size=${SUGGESTION_SIZE}&type=${searchType === 'schools' ? 'c' : 'p'}`
      )
    );
    const fetchProductSuggestions = memoize(
      q => $.ajax(`${SUGGESTION_URL}fuzziproduct?laravel=1&keyword=${q}&size=${SUGGESTION_SIZE}&type=p`)
    );
    const fetchLocations = memoize(q => $.ajax(`${SUGGESTION_URL}location?laravel=1&keyword=${q}&size=40`));

    const sources = {
      categories: {
        name: 'categories',
        display: 'name',
        source: (q, sync, async) => fetchSuggestions(q).then(data => async(data[0].results)),
        templates: {
          header: headerTemplate('categories', 'Practices'),
          suggestion: data => standardSuggestion(data)
        },
        limit: 15
      },
      courses: {
        name: 'courses',
        display: 'name',
        source: (q, sync, async) => fetchSuggestions(q).then(data => async(data[1].results)),
        templates: {
          header: headerTemplate('courses', 'Courses'),
          suggestion: data => standardSuggestion(data)
        },
        limit: 15
      },
      productCategories: {
        name: 'productCategories',
        display: 'name',
        source: (q, sync, async) => fetchSuggestions(q).then(data => async(data[2].results)),
        templates: {
          header: headerTemplate('productCategories', 'Product Categories'),
          suggestion: data => standardSuggestion(data)
        },
        limit: 15
      }
    };


    if (pracInput.length) {
      switch (searchType) {
        case 'product':
          sources.productCategories.source = (q, sync, async) =>
            fetchProductSuggestions(q).then(data => async(data[0].results));

          pracInput.typeahead({}, sources.productCategories);
          break;

        case 'schools':
          sources.categories.source = (q, sync, async) => fetchSuggestions(q).then(data => async(data[0].results));
          sources.courses.source = (q, sync, async) => fetchSuggestions(q).then(data => async(data[1].results));

          pracInput.typeahead({},
            sources.courses, sources.categories, sources.productCategories
          );
          break;

        default:
          pracInput.typeahead({},
            sources.categories, sources.courses, sources.productCategories
          );
      }

      pracInput.typeahead('val', keywordValue);

      pracInput.bind('typeahead:render', (ev, suggestions, async, dataset) => {
        state[dataset].count = suggestions.length;

        $(`.tt-dataset-${dataset}`)
          .find('.count')
          .text(`${suggestions.length} Result${(suggestions.length !== 1 ? 's' : '')}`);
      });

      pracInput.bind('typeahead:select', (ev, suggestion) => {
        switch (searchType) {
          case 'schools':
          case 'practitioner':
            $('#search_practice').val(suggestion.practice_id);

            // See if we need to change directory (multidirectory search)
            switch (suggestion.practice_directory_type) {
              case 'p':
              case 'c':
                searchBar.find('form').attr('action', '/search').attr('method', 'get');
                searchBar.find('[name="search_code"]').val(suggestion.practice_directory_type);
                searchBar.find('[name="relative_path"]')
                  .val(suggestion.practice_directory_type === 'p' ? '/practice' : '/find_a_school');
                window.localStorage.setItem('keywords', suggestion.name);
                break;
              case 'm':
                searchBar.find('form').attr('action', '/products').attr('method', 'post');
                searchBar.find('[name="keywords"]').val(suggestion.name);
                searchBar.find('[name="search_type"]').val('product');
                window.localStorage.setItem('keywords', suggestion.name);
                break;
              default:
            }
            break;
          default:
        }
      });

      pracInput.on('change', function () {
        switch (searchType) {
          case 'product':
            $('#keywords').val($(this).val());
            break;
          default:
        }
      });
    }

    if (suburbInput.length) {
      suburbInput.typeahead({}, {
        name: 'suburbs',
        display: suggestion => `${suggestion.suburb} ${suggestion.postcode}`,
        source: (q, sync, async) => fetchLocations(q).then(data => async(data)),
        templates: { suggestion: data => `<div><div class="suggestion__text">${data.suburb} ${data.postcode}</div></div>` },
        limit: 40
      });

      suburbInput.typeahead('val', zipValue);
    }

    if (mobileSuburbInput.length) {
      mobileSuburbInput.typeahead({}, {
        name: 'suburbs-mobile',
        display: suggestion => `${suggestion.suburb} ${suggestion.postcode}`,
        source: (q, sync, async) => fetchLocations(q).then(data => async(data)),
        templates: { suggestion: data => `<div><div class="suggestion__text">${data.suburb} ${data.postcode}</div></div>` },
        limit: 40
      });

      mobileSuburbInput.typeahead('val', zipValue);
    }

    if (secondarySuburbInput.length) {
      secondarySuburbInput.typeahead({}, {
        name: 'suburbs-secondary',
        display: suggestion => `${suggestion.suburb} ${suggestion.postcode}`,
        source: (q, sync, async) => fetchLocations(q).then(data => async(data)),
        templates: { suggestion: data => `<div><div class="suggestion__text">${data.suburb} ${data.postcode}</div></div>` },
        limit: 40
      });

      secondarySuburbInput.typeahead('val', zipValue);
    }


    searchBar.on('click', '.section-title', function (e) {
      e.preventDefault();
      const el = $(this);
      if (el.hasClass('active')) {
        el.addClass('inactive').removeClass('active');
        el.find('button span').removeClass('vively-up').addClass('vively-down');
      } else {
        el.addClass('active').removeClass('inactive');
        el.find('button span').removeClass('vively-down').addClass('vively-up');
      }
    });

    $('.rich-text-input').on('keydown', (e) => {
      if (e.keyCode === 13) {
        searchBar.find('form').submit();
      }
    });

    searchBar.find('form').on('submit', () => {
      const suburb = $(this).find('[name="search_zip"]');
      const prac = $(this).find('[name="search_str"]');

      if (suburb.length && !suburb.val()) {
        alert('Please specify a postcode for your search.');
        return false;
      }

      if (prac.length && !prac.val()) {
        alert('Please specify a search criteria.');
        return false;
      }

      return true;
    });
  }

  updateSearchZipAutocomplete(value) {
    const input = document.getElementById('searchZipAutocomplete');
    if (input !== null) {
      input.value = value;
    }
  }
}



// WEBPACK FOOTER //
// ./vively/scripts/components/search-bar.js